<template>
  <div>
    <div class="search">
      <div class="left">
        <input type="text" :placeholder="abc" v-model="key"><img src="./../../assets/img/search.png" alt="">
      </div>
      <div class="right"  @click="queryData">搜索</div>
    </div>
    <div class="contentBox">
      <div class="homepagetab">
        <ul>
          <li v-for="item in tabList" @click="tabClick(item)" v-bind:class="{active: curTab === item.tab}">{{item.name}}</li>
        </ul>
      </div>
      <div class="homepageScroll">
        <SubScrollBar v-if="curTab == 'dakalive'" :url="curUrl" :ref="curTab"></SubScrollBar>
        <scroll-bar v-if="curTab !== 'dakalive'" :url="curUrl" :ref="curTab"></scroll-bar>
      </div>
    </div>
    <returnPre></returnPre>
  </div>
</template>

<script>
  import SubScrollBar from 'src/components/Commons/SubScrollBars'
  export default {
    name: "searchList",
    data() {
      return {
        tabList: [
          {tab: 'meet', url: 'api/meeting/getMeetings?', name: '技术峰会'},
          {tab: 'video', url: 'api/video/getvideos?', name: '大咖视频'},
          {tab: 'dakalive', url: 'api/live/zsLiveList?', name: '大咖直播'}
        ],
        curUrl: '',
        curTab: 'meet', // 当前的tab
        key: '', // 上一个页面传过来的关键字 用于搜索
        abc: '搜索峰会、视频、直播、大咖'
      }
    },
    components: {
      SubScrollBar
    },
    created() {
      this.initData()
    },
    mounted() {
      this.getShareInfo()
    },
    methods: {
      // 初始化
      initData() {
        this.key = this.$route.query.key
        // 拼入关键字 进行搜索
        this.curUrl = this.tabList[0].url + 'keyword=' + this.key + '&'
        /*
        this.tabList.forEach(item =>{
          item.url += 'keyword=' + this.key + '&'
        })
        */
      },
      // 点击tab
      tabClick(item) {
        this.curTab = item.tab
        this.curUrl = item.url + 'keyword=' + this.key + '&'
      },
      // 获取数据
      queryData() {
        this.curUrl = this.tabList[0].url + 'keyword=' + this.key + '&'
        this.curTab = this.tabList[0].tab
        /*
        this.tabList.forEach(item =>{
          item.url = 'keyword=' + this.key + '&'
        })
        */
        this.$router.push({path: '/searchList', query: {key: this.key}})
      }
    }
  }
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  input {
    border: none;
    outline-style: none;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  .search {
    background-color: #f4f4f4;
    // padding: 14px 19px 16px 26px;
    box-sizing: border-box;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 750px;
    z-index: 100;
    .left {
      float: left;
      position: relative;
      input {
        height: 54px;
        width: 570px;
        border-radius: 10px;
        border: 1px solid #e7e7e7; /*no*/
        padding-left: 60px;
        box-sizing: border-box;
        margin-left: 26px;
        margin-top: 14px;
        margin-bottom: 16px;
      }
      img {
        position: absolute;
        height: 40px;
        left: 40px;
        top: 20px;
      }
    }
    .right {
      width: 126px;
      float: right;
      height: 50px;
      box-sizing: border-box;
      margin-right: 16px;
      margin-top: 16px;
      font-size: 26px;
      text-align: center;
      line-height: 50px;
    }
  }
  .category img {
    position: static !important;
  }
  ::-webkit-input-placeholder {
    /*Chrome/Safari*/
    color: #d1d1d1;
    font-size: 22px;
  }
  ::-moz-placeholder {
    /*Firefox*/
    color: #d1d1d1;
    font-size: 22px;
  }
  ::-ms-input-placeholder {
    /*IE*/
    color: #d1d1d1;
    font-size: 22px;
  }
  .contentBox{
    position: relative;
    top: 86px;
  }
  .homepagetab ul {
    /* width: 750px; */
    padding: 9px 29px 0 29px;
    box-sizing: border-box;
    list-style: none;
    display: flex;
    background: #f3f5f2 url(./../../assets/img/dian_bg.png) repeat-x left bottom;
    li {
      width: 220px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      flex: 1;
      font-size: 26px;
    }
    .active {
      color: #3e92cb;
      background: #3e92cb;
      background: url(./../../assets/img/selectbg.png);
      background-size: 100%;
      z-index: 10;
    }
  }

  .stop {
    position: fixed;
    top: 80px;
    width: 750px;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/SearchList.vue